<template>
  <div class="columns login-container">

    <div class="column first">
      <img src="../assets/logoKDCA-white.svg" width="500px" alt="Logo KDCA" />
    </div>

    <div class="column">
      <div v-if="showLoginContainer" class="login-container">
        <div class="welcome-title">{{ CONSTANTS.getCopy('LOGIN_WELCOME_TITLE') }}</div>
        <div class="welcome-subtitle">{{ CONSTANTS.getCopy('LOGIN_WELCOME_SUBTITLE') }}</div>

        <div class="field">
          <p class="control has-icons-left">
            <input class="input is-large" v-bind:placeholder="CONSTANTS.getCopy('LOGIN_EMAIL_PLACEHOLDER')" type="email" v-model="user.user">
            <span class="icon is-left"><i class="fas fa-user"></i></span>
          </p>
        </div>

        <div class="field">
          <p class="control has-icons-left">
            <input class="input is-large" v-bind:placeholder="CONSTANTS.getCopy('LOGIN_PASSWORD_PLACEHOLDER')" type="password" v-model="user.password">
            <span class="icon is-left"><i class="fas fa-lock"></i></span>
          </p>
        </div>

        <div class="control">
          <button class="button is-fullwidth is-dark" @click="login">{{ CONSTANTS.getCopy('LOGIN_BUTTON') }}</button>
        </div>
      </div>
      <div v-if="showTwoFactorAuthentication" class="login-container">
        <div class="welcome-title">{{ CONSTANTS.getCopy('LOGIN_TFA_TITLE') }}</div>
        <div class="welcome-subtitle">{{ CONSTANTS.getCopy('LOGIN_TFA_SUBTITLE') }}</div>

        <div class="field">
          <p class="control has-icons-left">
            <input class="input is-large" v-bind:placeholder="CONSTANTS.getCopy('LOGIN_CODE_PLACEHOLDER')" type="text" v-model="code" >
            <span class="icon is-left"><i class="fas fa-key"></i></span>
          </p>
        </div>
        <div class="control">
          <button class="button is-fullwidth is-dark" @click="checkCode">{{ CONSTANTS.getCopy('LOGIN_TFA_BUTTON') }}</button>
        </div>
      </div>
      <div v-if="showCreatePassword" class="login-container">
        <div class="welcome-title">{{ CONSTANTS.getCopy('LOGIN_CREATE_PW_TITLE') }}</div>
        <div class="welcome-subtitle">{{ CONSTANTS.getCopy('LOGIN_CREATE_PW_SUBTITLE_1') }}
          <p>{{ CONSTANTS.getCopy('LOGIN_CREATE_PW_SUBTITLE_2') }}</p>
        </div>
        <div class="field">
          <p class="control has-icons-left">
            <input class="input is-large" v-bind:placeholder="CONSTANTS.getCopy('LOGIN_PASSWORD_PLACEHOLDER')" type="password" v-model="password1" >
            <span class="icon is-left"><i class="fas fa-lock"></i></span>
          </p>
        </div>
        <div class="field">
          <p class="control has-icons-left">
            <input class="input is-large" v-bind:placeholder="CONSTANTS.getCopy('LOGIN_REPEAT_PASSWORD_PLACEHOLDER')" type="password" v-model="password2" >
            <span class="icon is-left"><i class="fas fa-lock"></i></span>
          </p>
        </div>
        <div v-if="showDiffPasswordErrror" class="text-error pbottom-1">{{ CONSTANTS.getCopy('LOGIN_CREATE_PW_DIFF_ERROR') }}</div>
        <div v-if="showPasswordError" class="text-error pbottom-1">{{ CONSTANTS.getCopy('LOGIN_CREATE_PW_REQ_ERROR') }}</div>
        <div class="control">
          <button class="button is-fullwidth is-dark" @click="checkPassword">{{ CONSTANTS.getCopy('LOGIN_CREATE_PW_BUTTON') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Auth from '../models/auth'
import Crisp from '../models/crisp'
import CONSTANTS from '../constants'

export default {
  data () {
    return {
      user: {
        user: null,
        password: null
      },
      code: null,
      password1: null,
      password2: null,
      showLoginContainer: true,
      showTwoFactorAuthentication: false,
      showCreatePassword: false,
      regExpPW: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%.^&*()_+])[A-Za-z\d!@#$%.^&*()_+]{10,}$/,
      showDiffPasswordErrror: false,
      showPasswordError: false,
      loginResponse: null
    }
  },
  created () {
    this.user = {
      user: '',
      password: ''
    }

    Crisp.hide()
  },
  methods: {
    login () {
      this.api.post('/UserBackLogin', this.user).then(response => {
        if (response.user.blocked) {
          this.dialog.alert({message: CONSTANTS.getCopy('LOGIN_CODE_INVALID_ERROR')}).then(() => window.location.reload())
          return
        }
        if (response.user.emailnovalid) {
          this.dialog.alert({message: CONSTANTS.getCopy('LOGIN_NO_VALID_EMAIL_ERROR')}).then(() => window.location.reload())
          return
        }
        this.loginResponse = response
        this.api.post('/UserBackCodeGet', null, true, this.loginResponse.user.accessKey).then(() => {
          this.showLoginContainer = false
          this.showTwoFactorAuthentication = true
        })
      })
    },
    checkCode () {
      this.api.post('/UserBackCodeCheck', {code: this.code}, true, this.loginResponse.user.accessKey).then((response) => {
        if (response.result === 'ERROR_CODE') {
          this.dialog.alert({message: CONSTANTS.getCopy('LOGIN_CODE_INVALID_ERROR')})
          return
        }
        if (response.result === 'ERROR_DATE') {
          this.dialog.alert({message: CONSTANTS.getCopy('LOGIN_CODE_TIME_OUT_ERROR')})
          return
        }
        if (this.loginResponse.user.newuser) {
          this.showTwoFactorAuthentication = false
          this.showCreatePassword = true
          return
        }
        Auth.setAuthorization(this.loginResponse.user)
        if (this.loginResponse.user.admin === 1) this.$router.push('/clients')
        if (this.loginResponse.user.responsible === 1) this.$router.push('/contacts')
        if (this.loginResponse.user.agent === 1) this.$router.push('/chats')
        this.showLastLogin()
      })
    },
    checkPassword () {
      this.showDiffPasswordErrror = false
      this.showPasswordError = false
      if (this.password1 !== this.password2) {
        this.showDiffPasswordErrror = true
        return
      }
      if (!this.regExpPW.test(this.password1)) {
        this.showPasswordError = true
        return
      }
      this.api.post('/UserBackNewPassword', {newpassword: this.password1}, true, this.loginResponse.user.accessKey).then(() => {
        Auth.setAuthorization(this.loginResponse.user)
        if (this.loginResponse.user.admin === 1) this.$router.push('/clients')
        if (this.loginResponse.user.responsible === 1) this.$router.push('/contacts')
        if (this.loginResponse.user.agent === 1) this.$router.push('/chats')
        this.showLastLogin()
      })
    },
    showLastLogin () {
      this.api.post('/UserBackLastLogin').then((response) => {
        let message = '<div style="font-size: 14px"><b>' + CONSTANTS.getCopy('LOGIN_LAST_LOGIN_DIALOG_1') + '</b>' + response.user.lastLogin + '<br><br>' +
          '<b>' + CONSTANTS.getCopy('LOGIN_LAST_LOGIN_DIALOG_2') + '</b><br><br>' +
          CONSTANTS.getCopy('LOGIN_LAST_LOGIN_DIALOG_3') + '<br><br>' + CONSTANTS.getCopy('LOGIN_LAST_LOGIN_DIALOG_4') +
          '<br><br>' + CONSTANTS.getCopy('LOGIN_LAST_LOGIN_DIALOG_5') + '</div>'
        this.dialog.alert({message})
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue